import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './lib/useAuth';
import { ToastProvider } from './components/Toast';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout';
import { LoginPage } from './pages/LoginPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { EquipmentListPage } from './pages/EquipmentListPage';
import { EquipmentEditPage } from './pages/EquipmentEditPage';
import { ExercisesListPage } from './pages/ExercisesListPage';
import { ExerciseEditPage } from './pages/ExerciseEditPage';
import { CoversPage } from './pages/CoversPage';
import { AdminsPage } from './pages/AdminsPage';
import { ReviewPage } from './pages/ReviewPage';
import { lastPath } from './lib/keepSignedIn';

export function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to={lastPath()} replace />} />
            <Route path="equipment" element={<EquipmentListPage />} />
            <Route path="equipment/:id" element={<EquipmentEditPage />} />
            <Route path="exercises" element={<ExercisesListPage />} />
            <Route path="exercises/:id" element={<ExerciseEditPage />} />
            <Route path="review" element={<ReviewPage />} />
            <Route path="covers" element={<CoversPage />} />
            <Route path="admins" element={<AdminsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ToastProvider>
    </AuthProvider>
  );
}
